import { navigate } from 'svelte-navigator';
import { user } from '../stores';
import { auth } from '../firebase';
import { db } from '../database';

export async function signup(email, password) {
  return auth.createUserWithEmailAndPassword(email, password);
}

export async function signinemail(email, password) {
  return auth.signInWithEmailAndPassword(email, password);
}

export async function doLogin(firebaseUser) {
  const { email, uid, displayName, photoURL } = firebaseUser;
  try {
    DD_LOGS.logger.info('LOGIN', { email, uid, displayName, photoURL });
  } catch (error) {
    console.error(error);
  }

  const newU = {
    loggedIn: true,
    email,
    uid,
    displayName,
    photoURL,
  };
  user.set({ ...user, ...newU });
  db.login.add(newU);
  navigate('/teach');
}

export async function doLogout() {
  try {
    DD_LOGS.logger.info('LOGOUT', { email: user.email, uid: user.uid });
  } catch (error) {
    console.error(error);
  }
  return auth.signOut().then(() => {
    user.set({ loggedIn: false });
    navigate('/');
  });
}
